import { render, staticRenderFns } from "./DeleteRecordDetail.vue?vue&type=template&id=044b4ac8&scoped=true&"
import script from "./DeleteRecordDetail.vue?vue&type=script&lang=js&"
export * from "./DeleteRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./card-detail.css?vue&type=style&index=0&id=044b4ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044b4ac8",
  null
  
)

export default component.exports